export default "__VITE_ASSET__5df64eab__"